<template>
<div class="select-pup-box">
    <div class="select-box hide-scrollbar">
      <p v-for="(item) in list" @click="selectItem(item)">{{ item }}</p>
    </div>
</div>
</template>
<script>
export default {
  name: 'SelectPopup',
  // 传入的选项列表
  props:['list'],
  data() {
    return {
    }
  },
  methods: {
    // 选中某一项，通过 changeCountryBank 事件通知父组件（国家/银行选择）
    selectItem(name) {
      this.$emit('changeCountryBank',name)
    }
  }
}
</script>
<style scoped>
.select-pup-box{
    width: 100%;
    max-height: 70vh;
    background: #FFFFFF;
    border-radius: 24px 24px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 3;
    font-family: "Mada";
    /* padding: 0 48px; */
    /* padding-top: 32px;
    padding-bottom: 40px; */
    box-sizing: border-box; 
    overflow-y: scroll;
}
.select-box{
  width: 576px;
  margin: 0 auto;
}
.select-box p{
  font-size: 28px;
  font-weight: 500;
  color: #121212;
  line-height: 100px;
  border-bottom: 1px solid #F1F1F1;
}
.select-box p:last-child{
  border-bottom: none;
  padding-bottom: 20px;
}
/* 隐藏滚动条 */
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.hide-scrollbar::-webkit-scrollbar {
    display: none; /* WebKit */
  }
</style>